import { Route, AppId, createPageRoute } from '@lumapps/router';

export const coveoSearchSettingsRoute: Route = createPageRoute({
    slug: 'search-settings/coveo',
    id: 'coveo-search-settings',
    appId: AppId.backOffice,
});

export const coveoSearchSettings = (): Route => coveoSearchSettingsRoute;
